<template>
  <div style="position: relative; width: 100%">
    <el-dropdown :tabindex="-1" max-height="20vh" placement="bottom-start" ref="dropdownRef" trigger="contextmenu" @command="updateFIODropdown">
      <div class="dropdown-input-area"></div>
      <template #dropdown>
        <el-dropdown-menu style="min-width: 120px">
          <el-dropdown-item v-for="(option, index) in suggestedOptions" :key="index" :command="option" :disabled="option.disabled" :class="option.class">
            {{ option.value ? option.value : `${option}` }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <input v-bind="$attrs" ref="inputRef" class="inputCustom" :value="input" @input="inputFio" placeholder="ФИО" />
  </div>
</template>

<script setup>
import { getSuggestedFio } from '@/utils/getDataForm';
import { limitInput } from '@/utils/handleChangeForm';
import { debounce } from '@/utils/setDebounce';
import { ref, watch } from 'vue';

const suggestedOptions = ref([]);
const dropdownRef = ref();

const inputRef = ref();

const props = defineProps({
  fio: String,
  disabledCustom: Boolean,
  onChangeSideEffect: Function,
  // eslint-disable-next-line vue/require-prop-type-constructor
  inheritAttrs: false,
});
const emit = defineEmits(['update:fio']);

const input = ref('');

watch(
  () => props.fio,
  (newVal) => {
    input.value = newVal;
    props.onChangeSideEffect();
  }
);

const updateFIODropdown = (value) => {
  inputRef.value.focus();

  setTimeout(() => {
    inputRef.value.focus();
  }, 300);

  const isLastWord = value.split(' ').length === 3;
  const formattedValue = isLastWord ? value : value + ' ';
  input.value = formattedValue;
  emit('update:fio', formattedValue);
  props.onChangeSideEffect();
};

async function getSuggestedOptions(value) {
  if (value.length > 2) {
    try {
      suggestedOptions.value = await getSuggestedFio(value);

      if (suggestedOptions.value.length < 1) {
        suggestedOptions.value[0] = {
          disabled: true,
          class: 'disable-notice',
          value: 'Нет результатов',
        };

        dropdownRef.value.handleOpen();
      } else {
        suggestedOptions.value.unshift({
          disabled: true,
          class: 'disable-notice',
          value: 'Выберите ФИО',
        });
        dropdownRef.value.handleOpen();
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    dropdownRef.value.handleClose();
  }
}

const getOptionsDebounce = debounce(getSuggestedOptions, 500);

const inputFio = (e) => {
  let value = e.target.value;
  value = limitInput(value);
  input.value = value;
  emit('update:fio', value);
  props.onChangeSideEffect();
  if (props.fio.length <= 1) {
    dropdownRef.value.handleClose();
    suggestedOptions.value = [];
  } else {
    dropdownRef.value.handleOpen();
    suggestedOptions.value[0] = { disabled: true, class: 'disable-notice', value: 'Поиск...' };
  }
  getOptionsDebounce(props.fio);
};
</script>

<style scoped></style>
